import type { Vote } from '../shared/index.js';

export const s = {
  name: 'Red Flag / Green Flag',
  pitch: 'Durumu oku, gizlice bayrağını kaldır, kim ne dedi gör',
  vote: { green: 'Green flag', red: 'Red flag', never: 'Asla olmaz' } satisfies Record<Vote, string>,
  voteShort: { green: 'Green', red: 'Red', never: 'Asla' } satisfies Record<Vote, string>,
  /** Sınır testi kartlarında seçeneklerin adı. */
  limitVote: { green: 'Varım', red: 'Hayır', never: 'Sınırım' } satisfies Record<Vote, string>,
  settings: {
    categories: 'Kategoriler',
    categoriesHint: '+18 kategoriler varsayılan olarak kapalıdır.',
    adultWarning: (names: string) => `${names} açık cinsel içerik içerir; yalnızca yetişkinler içindir.`,
    dealBreaker: 'Üçüncü seçenek',
    dealBreakerHint: 'Green ve red’in yanına “Asla olmaz” eklenir.',
    names: 'Kim ne dedi',
    open: 'Açık',
    anonymous: 'İsimsiz',
    namesHint: (anon: boolean) =>
      anon ? 'Yalnızca dağılım görünür. Kimin ne dediği kimseye gönderilmez.' : 'Açıklamada herkesin oyu adıyla görünür.',
    predict: 'Tahmin modu',
    predictHint: 'Oyuna ek olarak çoğunluğun ne diyeceğini tahmin et; tutarsa +1 puan.',
    seconds: 'Oy süresi',
    sec: (n: number) => (n === 0 ? 'Süresiz' : `${n} sn`),
    secondsHint: (n: number) => (n === 0 ? 'Herkes oy verince açılır.' : 'Süre bitince verilen oylar açılır.'),
    discuss: 'Tartışma süresi',
    discussHint: (n: number) =>
      n === 0 ? 'Herkes hazır olunca ya da oda sahibi geçince devam edilir.' : `Oylar açılınca ${n} sn tartışılır, sonra sıradaki durum gelir.`,
    rounds: 'Durum sayısı',
    unlimited: 'Sınırsız',
    roundsHint: (n: number) => (n === 0 ? 'Oda sahibi bitirene kadar sürer.' : `${n} durumdan sonra özet gelir.`),
    on: 'Açık',
    off: 'Kapalı',
    readOnly: 'Ayarları oda sahibi seçer.',
    add: 'Durum ekle',
    addHint: 'Eklediğin durum “Arkadaşların ekledikleri” kategorisine girer ve kimseye listelenmez.',
    addPlaceholder: 'Ör. Sevgilin doğum gününde sana spor salonu üyeliği hediye ediyor.',
    addSave: 'Durumu ekle',
    addSaving: 'Ekleniyor…',
    addSaved: 'Eklendi. Oyunda karşınıza çıkacak.',
    addFailed: 'Eklenemedi. Tekrar dene.',
  },
  play: {
    round: (n: number, total: number | null) => (total ? `Durum ${Math.min(n + 1, total)}/${total}` : `Durum ${n + 1}`),
    roundDone: (n: number, total: number | null) => (total ? `Durum ${n}/${total}` : `Durum ${n}`),
    you: 'sen',
    pick: 'Sen ne dersin?',
    pickHint: 'Bayrağını gizlice kaldır.',
    picked: 'Oyun gizli. Açılana kadar değiştirebilirsin.',
    guessTitle: 'Çoğunluk ne diyecek?',
    guessHint: 'Doğru tahmin +1 puan.',
    guessFirst: 'Önce kendi oyunu ver.',
    waiting: (done: number, total: number) => `${done}/${total} kişi oy verdi`,
    untimed: 'Süresiz',
    voters: 'Oyuncular',
    votedTag: 'verdi',
    thinkingTag: 'düşünüyor',
    readyTag: 'hazır',
    offline: 'bağlantı yok',
    revealNow: 'Oyları şimdi aç',
    skip: 'Durumu atla',
    hostTools: 'Oda sahibi',
    nobody: 'Kimse oy vermedi.',
    majority: (v: string) => `Çoğunluk: ${v}`,
    tie: 'Oylar bölündü',
    unanimous: 'Herkes aynı fikirde',
    yourVote: (v: string) => `Sen: ${v}`,
    guessHit: 'Tahminin tuttu, +1',
    guessMiss: (v: string) => `Tahminin ${v} idi, tutmadı`,
    noGuess: 'Tahmin vermedin',
    anonNote: 'İsimsiz mod: kimin ne dediği gönderilmez.',
    next: 'Sonraki durum',
    nextIn: (s: number) => `Tartışın… ${s}`,
    discussing: 'Tartışın…',
    secs: (n: number) => `${n} sn`,
    ready: 'Hazırım',
    readyDone: 'Hazırsın',
    readyCount: (n: number, total: number) => `${n}/${total} kişi hazır. Herkes hazır olunca ya da oda sahibi geçince devam edilir.`,
    readyCountTimed: (n: number, total: number) => `${n}/${total} kişi hazır. Süre bitince, herkes hazır olunca ya da oda sahibi geçince devam edilir.`,
    points: 'puan',
    scores: 'Tahmin puanı',
  },
  podium: {
    gameOver: 'Oyun bitti',
    title: 'Red flag toleransı',
    sub: (n: number) => `${n} durum oylandı`,
    mostGreen: 'En hoşgörülü',
    strictest: 'En katı',
    rebel: 'En aykırı',
    rebelNote: (n: number) => `${n} kez azınlıkta kaldı`,
    tolerance: (n: number) => `%${n} green`,
    profiles: 'Herkesin profili',
    mine: 'Senin profilin',
    anonNote: 'İsimsiz oynandığı için yalnızca kendi profilini görüyorsun.',
    divisive: 'En çok bölen durumlar',
    noDivisive: 'Bu oyunda herkes hep aynı fikirdeydi.',
    scores: 'Tahmin puanları',
    totals: 'Toplam oylar',
    back: 'Lobiye dönülüyor…',
  },
  howto: {
    title: 'Nasıl oynanır',
    steps: [
      ['Durumu oku', 'Her turda bir durum çıkar: ilişki, iş, ev arkadaşı, aile ve daha fazlası.'],
      ['Gizlice oy ver', 'Green flag mi, red flag mi? Açıksa “Asla olmaz” da seçebilirsin. Kimse açılana kadar oyunu göremez.'],
      ['Çoğunluğu tahmin et', 'Tahmin modunda grubun çoğunluğunun ne diyeceğini de seç. Tutarsa +1 puan.'],
      ['Tartış', 'Oylar birlikte açılır. Dağılıma bakın, tartışın, hazır olunca sıradaki duruma geçin.'],
    ] as [string, string][],
  },
};
